import { env } from "@/common/env/client.mjs";

export const getHandlersDelay = () => (env.NODE_ENV === "test" ? 100 : 1000);
